import React from "react";

// Shared button style constants. Each admin component had its own
// inline btnPri / btnSec / btnGhost objects, so any change to the
// primary button color or radius required a sweep across N files.
// New surfaces should import from here; existing surfaces migrate
// opportunistically.
//
// Focus-visible: all four base styles share a focus ring class so
// keyboard users can tell where focus is. Inline-style objects can't
// carry pseudo-class declarations, so the ring lives in a global
// stylesheet (loaded once via FocusVisibleStyles below) and the buttons
// pick it up via the data-fv-ring attribute pattern, or simply by being
// any <button> on the page.

export const btnPri: React.CSSProperties = {
  padding: "8px 16px",
  background: "var(--brand-primary)",
  color: "white",
  border: "none",
  borderRadius: "4px",
  fontSize: "13px",
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: "inherit",
};

export const btnPriSm: React.CSSProperties = {
  ...btnPri,
  padding: "6px 12px",
  fontSize: "12px",
};

export const btnSec: React.CSSProperties = {
  padding: "8px 16px",
  background: "white",
  color: "#374151",
  border: "1px solid #E5E7EB",
  borderRadius: "4px",
  fontSize: "13px",
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: "inherit",
};

export const btnSecSm: React.CSSProperties = {
  ...btnSec,
  padding: "6px 12px",
  fontSize: "12px",
};

export const btnGhost: React.CSSProperties = {
  padding: "6px 12px",
  background: "transparent",
  color: "#6B7280",
  border: "1px solid #E5E7EB",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: "inherit",
};

// Destructive action — confirm dialog should always wrap this.
export const btnDanger: React.CSSProperties = {
  ...btnPri,
  background: "#B91C1C",
};

// Disabled overlay — apply on top of any btn* style when the action
// isn't available yet.
export const btnDisabled: React.CSSProperties = {
  opacity: 0.5,
  cursor: "not-allowed",
};

// Mount this once near the root of the app. Adds a global :focus-visible
// outline to every <button> and form input so keyboard users can see
// where focus is. CSS only — no JS, no global event listeners. Modern
// browsers compute :focus-visible from user-input modality, so mouse
// clicks don't trigger the ring (only Tab/arrow-key navigation does).
export function FocusVisibleStyles() {
  return (
    <style>{`
      button:focus-visible,
      input:focus-visible,
      select:focus-visible,
      textarea:focus-visible,
      a:focus-visible {
        outline: 2px solid var(--brand-primary);
        outline-offset: 2px;
        border-radius: 4px;
      }
    `}</style>
  );
}
